// extracted by mini-css-extract-plugin
module.exports = {"container":"dT_S7","small":"RmYfJ","triangle":"qqj-Y","top":"_2hxlc"};